module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "transfer-detail__title"
  }, [_vm._v("应收账款转让通知书详情")]), _vm._v(" "), _c('div', {
    staticClass: "transfer-detail__content"
  }, [_c('el-radio-group', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    model: {
      value: (_vm.pdfTabShow),
      callback: function($$v) {
        _vm.pdfTabShow = $$v
      },
      expression: "pdfTabShow"
    }
  }, [(_vm.adviceDetail.adviceConfirmSource === '1' && _vm.adviceDetail.adviceState === '1') ? _c('el-radio-button', {
    staticClass: "transfer-detail__pdf-tab",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("转让通知书回执")]) : _vm._e(), _vm._v(" "), _c('el-radio-button', {
    staticClass: "transfer-detail__pdf-tab",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("转让通知书")])], 1), _vm._v(" "), _c('div', {
    staticClass: "transfer-detail__pdfs"
  }, [_c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pdfTabShow == 1),
      expression: "pdfTabShow==1"
    }],
    staticClass: "transfer-detail__pdf",
    attrs: {
      "src": _vm.deliveryPdfUrl
    }
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pdfTabShow == 2),
      expression: "pdfTabShow==2"
    }],
    staticClass: "transfer-detail__pdf",
    attrs: {
      "src": _vm.advicePdfUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "transfer-detail__bottom"
  }, [_c('el-button', {
    staticClass: "transfer-detail__back-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("返回")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da64b6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/TransferAdviceDetail.vue
// module id = 999
// module chunks = 1